module.exports = "/lucky-balls/img/jackpot/016.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/jackpot/016.png
// module id = 1116
// module chunks = 0